import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FaHome } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useBranch } from '~/contexts/BranchContext';

const NotFoundPage: React.FC = () => {
	const { t } = useTranslation();
	const { theme } = useBranch();


	return (
		<section className="min-h-[80vh] flex items-center justify-center py-12 px-4">
			<motion.div
				className="text-center max-w-lg"
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.6 }}
			>
				<motion.div
					initial={{ scale: 0.8, opacity: 0 }}
					animate={{ scale: 1, opacity: 1 }}
					transition={{ duration: 0.5, delay: 0.2 }}
					className="mb-8"
				>
					<span className="text-9xl font-bold" style={{ border: theme?.textColor }}>404</span>
				</motion.div>

				<h1 className="text-3xl font-bold  mb-4" style={{ border: theme?.textColor }}>
					{t('notFound.title')}
				</h1>

				<p className="mb-8" style={{ border: theme?.textColor }}>
					{t('notFound.message')}
				</p>

				<Link to="/">
					<motion.button
						className="inline-flex items-center gap-2 text-white px-6 py-3 rounded-lg font-semibold cursor-pointer  transition-colors duration-300"
						whileHover={{ scale: 1.05 }}
						whileTap={{ scale: 0.95 }}
						style={{ backgroundColor: theme?.backgroundColor }}
					>
						<FaHome />
						{t('notFound.homeButton')}
					</motion.button>
				</Link>
			</motion.div>
		</section>
	);
};

export default NotFoundPage;